// Action types + plain action creators only. The signUp / verify thunks that
// used to live here were never dispatched (the sign-up and verify screens call
// containers/Login/UserFunctions.js directly); SignupReducer consumes the
// constants below.
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNUP_SUCCESS_RESPONSE = "SIGNUP_SUCCESS_RESPONSE";
export const SIGNUP_LOADING = "SIGNUP_LOADING";
export const VERIFY_ERROR = "SIGNUP_ERROR";
export const VERIFY_SUCCESS_RESPONSE = "SIGNUP_SUCCESS_RESPONSE";
export const VERIFY_LOADING = "SIGNUP_LOADING";



export function signupErrorResponse(error) {
  return {
    type: SIGNUP_ERROR,
    ...error,
  };
}

export function verifyErrorResponse(error) {
  return {
    type: VERIFY_ERROR,
    ...error,
  };
}


export function signupResponse(response) {
  return {
    type: SIGNUP_SUCCESS_RESPONSE,
    response,
  };
}

export function verifyResponse(response) {
  return {
    type: VERIFY_SUCCESS_RESPONSE,
    response,
  };
}
